import {Input, Tag, Tooltip} from 'antd';
import {
  DeleteOutlined,
  EditOutlined,
  PictureOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import styles from './FlowBuilder.module.scss';

/** Single row inside a column (category / feature / issue). */
export const Row = ({
  record,
  active,
  title,
  subtitle,
  icon,
  flowId,
  onClick,
  onEdit,
  onDelete,
}) => (
  <div
    data-flow-row={flowId}
    className={`${styles.row} ${active ? styles.activeRow : ''} ${
      record.isActive === false ? styles.inactiveRow : ''
    }`}
    onClick={onClick}>
    <div className={styles.rowIcon}>
      {icon ? (
        <img src={icon} alt="" />
      ) : (
        <PictureOutlined style={{color: '#94a3b8'}} />
      )}
    </div>

    <div className={styles.rowBody}>
      <span className={styles.rowTitle}>{title}</span>
      {subtitle || record.isActive === false ? (
        <span className={styles.rowMeta}>
          {record.isActive === false ? (
            <Tag color="default" style={{margin: 0}}>
              Inactive
            </Tag>
          ) : null}
          {subtitle ? <span>{subtitle}</span> : null}
        </span>
      ) : null}
    </div>

    <div className={styles.rowActions} onClick={e => e.stopPropagation()}>
      <Tooltip title="Edit">
        <button type="button" className={styles.rowActionBtn} onClick={onEdit}>
          <EditOutlined />
        </button>
      </Tooltip>
      <Tooltip title="Delete">
        <button
          type="button"
          className={`${styles.rowActionBtn} ${styles.rowActionDanger}`}
          onClick={onDelete}>
          <DeleteOutlined />
        </button>
      </Tooltip>
    </div>
  </div>
);

/** Themed "no data" / "loading" / "select parent" placeholder. */
export const EmptyState = ({icon: Icon, title, hint}) => (
  <div className={styles.emptyState}>
    <Icon className={styles.emptyIcon} />
    <div className={styles.emptyTitle}>{title}</div>
    <div className={styles.emptyHint}>{hint}</div>
  </div>
);

/** One of the three drill-down columns. */
export const Column = ({
  title,
  count,
  addDisabled,
  onAdd,
  search,
  onSearchChange,
  searchPlaceholder,
  showSearch = true,
  children,
}) => (
  <div className={styles.column}>
    <div className={styles.columnHeader}>
      <div className={styles.columnHeaderTitle}>
        <h3>{title}</h3>
        <span className={styles.countBadge}>{count}</span>
      </div>
      <button
        type="button"
        className={styles.addButton}
        disabled={addDisabled}
        onClick={onAdd}>
        <PlusOutlined /> Add
      </button>
    </div>

    {showSearch ? (
      <div className={styles.columnSearch}>
        <Input
          allowClear
          size="small"
          prefix={<SearchOutlined style={{color: '#94a3b8'}} />}
          placeholder={searchPlaceholder || 'Search…'}
          value={search}
          onChange={e => onSearchChange?.(e.target.value)}
        />
      </div>
    ) : null}

    <div className={styles.columnBody} data-flow-scroll>
      {children}
    </div>
  </div>
);
